(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const enabled = (name) => root.dataset[name] === 'true';

  const setupScrollProgress = () => {
    if (!enabled('spotoScrollProgress') || document.getElementById('spoto-scroll-progress')) return;

    const progress = document.createElement('div');
    progress.id = 'spoto-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);

    const update = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const value = scrollable > 0 ? Math.min(Math.max(window.scrollY / scrollable, 0), 1) : 0;
      root.style.setProperty('--spoto-scroll-progress', value.toFixed(4));
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  };

  const setupBackToTop = () => {
    if (!enabled('spotoBackToTop') || document.getElementById('spoto-back-top')) return;

    const button = document.createElement('button');
    button.id = 'spoto-back-top';
    button.type = 'button';
    button.dataset.visible = 'false';
    button.setAttribute('aria-label', root.dataset.spotoBackTopLabel || 'Voltar ao início');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>';
    document.body.appendChild(button);

    const update = () => {
      button.dataset.visible = window.scrollY > Number(root.dataset.spotoBackTopAfter || 600) ? 'true' : 'false';
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  const revealSelector = [
    '#MainContent > .shopify-section',
    '.product-card',
    '.collection-card',
    '.spoto-home-card',
    '.spoto-product-benefit',
    '.spoto-about__value',
    '.spoto-contact-card'
  ].join(',');

  const setupReveal = (scope = document) => {
    if (!enabled('spotoMotion') || reducedMotion.matches) return;

    const items = scope.querySelectorAll(revealSelector);
    if (!items.length) return;

    root.classList.add('spoto-motion-ready');

    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('spoto-in-view');
        activeObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => {
      if (item.dataset.spotoRevealReady === 'true') return;
      item.dataset.spotoRevealReady = 'true';
      item.classList.add('spoto-reveal-item');
      observer.observe(item);
    });
  };

  const setupRipple = (scope = document) => {
    if (!enabled('spotoRipple') || reducedMotion.matches) return;

    const excludedSelector = [
      '.spoto-language-selector__option',
      '.header-actions__action',
      '[data-testid="cart-drawer-trigger"]',
      'cart-icon',
      'cart-icon *'
    ].join(',');

    scope.querySelectorAll('.button, button').forEach((button) => {
      if (button.matches(excludedSelector) || button.querySelector('cart-icon')) {
        button.classList.remove('spoto-ripple-host');
        delete button.dataset.spotoRippleReady;
        return;
      }

      if (button.dataset.spotoRippleReady === 'true') return;
      button.dataset.spotoRippleReady = 'true';
      button.classList.add('spoto-ripple-host');

      button.addEventListener('pointerdown', (event) => {
        const rect = button.getBoundingClientRect();
        const ripple = document.createElement('span');
        ripple.className = 'spoto-ripple';
        ripple.style.left = event.clientX - rect.left + 'px';
        ripple.style.top = event.clientY - rect.top + 'px';
        button.appendChild(ripple);
        ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
      });
    });
  };

  const refresh = (scope = document) => {
    setupReveal(scope);
    setupRipple(scope);
  };

  const init = () => {
    setupScrollProgress();
    setupBackToTop();
    refresh();

    document.addEventListener('shopify:section:load', (event) => refresh(event.target));
    document.addEventListener('shopify:block:select', (event) => refresh(event.target));

    const mutationObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) refresh(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

